import React from 'react';

interface GlassPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  tinted?: boolean;
  radius?: 'xs' | 'sm' | 'md';
  as?: keyof JSX.IntrinsicElements;
}

const radii = { xs: 'rounded-xs', sm: 'rounded-sm', md: 'rounded-md' };

export default function GlassPanel({
  tinted = false,
  radius = 'md',
  className = '',
  children,
  as: Tag = 'div',
  ...rest
}: GlassPanelProps) {
  const Component = Tag as React.ElementType;
  return (
    <Component
      className={`${tinted ? 'glass-tinted' : 'glass'} ${radii[radius]} ${className}`}
      {...rest}
    >
      {children}
    </Component>
  );
}
